import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';
import { LoginScreen } from './pages/Login';
import { EmailLoginScreen } from './pages/EmailLogin';
import { AuthCallbackScreen } from './pages/AuthCallback';
import { AlreadyRegisteredScreen } from './pages/AlreadyRegistered';
import { RecoveryIdScreen } from './pages/RecoveryId';
import { RecoveryPasswordScreen } from './pages/RecoveryPassword';

export const LoginScreens: ScreenItem[] = [
  {
    name: 'Login',
    component: LoginScreen,
    path: WEB_ROUTE_PATHS.Login,
    options: {
      title: '로그인',
      presentation: 'fullScreenModal',
      gestureEnabled: false,
    },
  },
  {
    name: 'EmailLogin',
    component: EmailLoginScreen,
    path: WEB_ROUTE_PATHS.EmailLogin,
    options: {
      title: '로그인',
      presentation: 'fullScreenModal',
    },
  },
  {
    name: 'AuthCallback',
    component: AuthCallbackScreen,
    path: WEB_ROUTE_PATHS.AuthCallback,
    options: {
      title: '로그인',
      presentation: 'fullScreenModal',
      gestureEnabled: false,
    },
  },
  {
    name: 'AlreadyRegistered',
    component: AlreadyRegisteredScreen,
    path: WEB_ROUTE_PATHS.AlreadyRegistered,
    options: {
      title: '로그인',
      presentation: 'fullScreenModal',
    },
  },
  {
    name: 'RecoveryId',
    component: RecoveryIdScreen,
    path: WEB_ROUTE_PATHS.RecoveryId,
    options: {
      title: '아이디 찾기',
      presentation: 'fullScreenModal',
    },
  },
  {
    name: 'RecoveryPassword',
    component: RecoveryPasswordScreen,
    path: WEB_ROUTE_PATHS.RecoveryPassword,
    options: {
      title: '비밀번호 찾기',
      presentation: 'fullScreenModal',
    },
  },
];
